export default __webpack_public_path__ + "static/media/european-globe.5d639b57.png";